import * as types from '../types';
import moment from 'moment';
import update from 'immutability-helper';
import {
    INTERVIEW_RESULT_PENDING_NUM,
} from '@Utils/constants'

export const initialAddForm = {
    ID: 0,
    companyID: 0,
    applicantID: 0,
    applicantEmail: '',
    interviewer: 0,
    interviewerEmail: '',
    positionApplied: 0,
    applicantStatus: 0,
    interviewSchedule: moment().format('MM/DD/YYYY HH:mm'),
    interviewMode: 0,
    addressOrLink: '',
    remarks: '',
    positionLevel: 0, 
    positionAccepted: 0,
    recommendedSalary: 0,
    interviewResult: INTERVIEW_RESULT_PENDING_NUM,
    CreatedBy: 0,
    DateCreated: moment().format('MM/DD/YYYY HH:mm'),
}

const defaultState = {
    loading: false,
    addForm: { ...initialAddForm },
    emailTemplate: { subject: '', body: '' },
    holidayDates: [],
    alert: {
        show: false,
        title: 'Create success',
        content: 'Successfuly created record.',
        confirmLabel: 'Ok',
        goBackToListFlag: false,
    }
};

export default function addReducer(state = defaultState, action) {
    switch (action.type) {
        case types.CHG_FIELD:
        case types.CHG_STATUS:
        case types.CHG_EMPLOYEE_ID:
        case types.CHG_INCOME_ID:
        case types.CHG_AMOUNT:
        case types.CHG_EFFECTIVE_DATE:
        case types.CHG_MEMO:
            return update(state, {
                addForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            });
        case types.RESET_ADD_DATA:
            return update(state, {
                addForm: { $set: initialAddForm },
                alert: { $set: defaultState.alert }
            });
        case types.UPD_ADD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.UPD_ADD_MEMO_CHAR_COUNT:
            return update(state, {
                addForm: {
                    memoCharCount: { $set: state.addForm.memoCharCount - 1 }
                }
            });
        case types.INSERT_LOADING:
            return update(state, {
                loading: { $set: action.payload }
            });
        case types.HIDE_ADD_ALERT:
            return update(state, {
                alert: {
                    show: { $set: false }
                }
            });
        case types.SET_HOLIDAY_DATES:
            return update(state, {
                holidayDates: { $set: action.payload.holidayDates }
            });
        case types.SET_ADD_EMAIL_TEMPLATE:
            return update(state, {
                emailTemplate: { $set: action.payload }
            });
        default:
            return state;
    }
};
